import { DateTime } from "luxon";
import { ExistingStamp } from "../models";

export function getDaysAgoValue(lastStamp: ExistingStamp, currentTime: DateTime): number {
    return lastStamp.dateTime.startOf("day").diff(currentTime.startOf("day")).as("days");
}